export * from './IconLithologyFilled';
